import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { SvgProps } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

import type { AppColors } from '@squire/ui';

interface StarIconProps extends SvgProps {
  size?: number;
  color?: keyof AppColors;
}

export const StarIcon: React.FC<StarIconProps> = ({
  size = 24,
  color = 'iconPrimary',
  ...props
}) => {
  const { theme: colors } = useUnistyles();
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" {...props}>
      <Path
        d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
        fill={colors[color]}
      />
    </Svg>
  );
};
